export default function run($rootScope,$templateCache,$state,$stateParams,$timeout,MenuConstant,main) {
	MenuConstant[0]['menu'].push(main)
}

run.$inject = ['$rootScope','$templateCache','$state','$stateParams','$timeout','MenuConstant','main'];



// WEBPACK FOOTER //
// ./src/app/main-start/main.run.js